import privacy from '@images/privacy-choices.svg'
import Image from 'next/image'
import Link from 'next/link'
import { useEffect, useState  } from "react"

const ipUrl = (sourceUrl) => {
    const params = new URLSearchParams(window.location.search);
    const ip = params.get('_ip');

    if (!ip) return sourceUrl

    const url = new URL(sourceUrl)
    url.searchParams.set("_ip", ip)

    return url.toString()
}

const getClientCountry = async () => {
    try {
        const res = await fetch(ipUrl(`${process.env.NEXT_PUBLIC_APP_URL}/api/v1/tools/ip-info`))
        const locationData = await res.json()
        return locationData.country
    } catch (e) {
        console.warn('ip-info error')
        return null
    }
}

export default function FooterDataRequestLink() {
    const [countryCode, setCountryCode] = useState(null)

    useEffect(() => {
        getClientCountry().then(setCountryCode)
    }, [])

    if (countryCode !== 'US') return ''

    return (
        <>
            <span className="divider divider_solid divider_vertical" />
            <Link
                href="#"
                scroll={false}
                className="cmp-ccpa-link flex items-center !leading-5 hover:text-neutral2-300"
                onClick={(e) => e.preventDefault()}
            >
                <Image
                    src={privacy}
                    alt="Privacy Choices"
                    width={30}
                    height={14}
                    priority={false}
                    unoptimized
                />
                &nbsp;
                <span>Your Privacy Choices</span>
            </Link>
        </>
    )
}